export enum HttpStatusCodesEnum {
  NOT_FOUND = '404',
  BAD_REQUEST = '400',
  OK = '200',
}
